<template>
  <div class="view_box" :class="isAni ? 'ani':''">
    <div class="title">拉新Tips</div>
    <div class="text_font">首购权益刺激-加速首购转化</div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    isAni:{
      type:Boolean,
      default:true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@keyframes view_box_s {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.ani{
  animation: view_box_s 1.5s ease-in;
  animation-fill-mode: both;
  border-radius: 16px;
}
.view_box {
  position: relative;
  width: 100%;
  height: 100%;

  padding: 36px;
  font-size: 14px;
  color: #000000;
  line-height: 16px;
  text-align: center;
  font-family: PingFang SC;
  background-image: url("../../assets/images/yearReport/P11.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;


  div {
    font-family: PingFang SC;
    width: 100%;
    margin-bottom: 12px;
    text-align: center;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: 28px;
  }

  .text_font{
    color: rgba(0, 0, 0, 0.65);
    font-size: 16px;
  }
}
</style>